import { useConfigContext } from '@contexts/ConfigContext'

type FlagConfig = {
  auth: {
    enabled: boolean
  }
  locations: {
    displayConversionCouponInfo: boolean
  }
  maintenance: {
    banner: boolean
  }
  prePay: {
    enabled: boolean
  }
  youngAdultDiscount: {
    showPromoItems: boolean
    isPromoActive: boolean
  }
  updateLookupUx: {
    enabled: boolean
  }
  layoutRefresh: {
    displayPersonalInformationAdvisoryHeader: boolean
    displayPersonalInformationRevisedLayout: boolean
    displayAuthenticationRevisedLayout: boolean
    displayLocationSearchRevisedLayout: boolean
  }
}

/**
 * hook to always return the requested flag or undefined
 */
export const useFlag = <K extends keyof FlagConfig>(
  flag: K
): FlagConfig[K] | undefined => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { config } = useConfigContext() as any
  if (!config) {
    return undefined
  }
  return config[flag]
}
